export default __webpack_public_path__ + "static/media/bug-reports.cd65c0d6.svg";